import { getFirestore, collection, query, where, orderBy, addDoc, getDocs } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { db,auth } from "../firebase"; 



export const createProject = async (projectName) => {
  try {
    // Get the ID of the currently authenticated user
    const user = getAuth().currentUser;
    const userId = user.uid;
    const now = new Date();

    // Declare a new variable as a string and assign the value of projectName to it
    const name = String(projectName);

    // Set the "ownerId" field to the ID of the currently authenticated user
    const projectData = {
      projectName: name,
      ownerId: userId,
      status: "open",
      createdAt: now,
      updatedAt: now,
    };

    // Add the project to the "user_projects" collection
    const docRef = await addDoc(collection(db, "user_projects"), projectData);

    // Return the ID of the newly created project
    return docRef.id;
  } catch (error) {
    console.error("Error creating project: ", error);
  }
};

// Function to get the projects for the current user
export const getUserProjects = async () => {
  const auth = getAuth();
  const currentUser = auth.currentUser;
  if (!currentUser) {
    console.log("User not authenticated");
    return [];
  }

  const projectsRef = collection(db, "user_projects");
  const q = query(projectsRef, where("ownerId", "==", currentUser.uid), orderBy("createdAt"));
  const querySnapshot = await getDocs(q);

  const projects = [];
  querySnapshot.forEach((doc) => {
    const data = doc.data();
    const project = {
      id: doc.id,
      projectName: data.projectName,
      status: data.status,
      createdAt: data.createdAt.toDate().toLocaleDateString(),
      updatedAt: data.updatedAt.toDate().toLocaleDateString(),
    };
    projects.push(project);
  });
  return projects;
};

export const userSignOut = () => {
  signOut(auth)
    .then(() => {
      console.log("sign out successful");
    })
    .catch((error) => console.log(error));
};